/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import { Grid } from "@material-ui/core";
import { Link } from "react-router-dom";
import { PageHeader } from "../Common";

const BreadCrumb = ({ selectedModule, selectedSubPath }) => {
	return selectedSubPath && !selectedSubPath.hideNavBars && !selectedSubPath.hideBreadCrumbs ? (
		<Grid className="mt-3">
			<nav className="modules-breadcrumb bg-transparent" aria-label="breadcrumb">
				<ol className="breadcrumb p-0 bg-transparent">
					<li className="breadcrumb-item">
						<Link to="/">Home</Link>
					</li>
					{selectedSubPath ? (
						<>
							<li className="breadcrumb-item">
								<Link to={selectedModule.path}>{selectedModule.title}</Link>
							</li>
							<li className="breadcrumb-item active" aria-current="page">
								{selectedSubPath.title}
							</li>
						</>
					) : (
						<li className="breadcrumb-item active" aria-current="page">
							{selectedModule.title}
						</li>
					)}
				</ol>
			</nav>
			<div className="modules-breadcrumb">
				<PageHeader pageTitle={selectedSubPath.pageTitle} pageDescription={selectedSubPath.pageDescription} />
			</div>
		</Grid>
	) : (
		""
	);
};

export default BreadCrumb;
